import { useEffect, useState } from 'react';
import api, { ApiError } from '../lib/apiClient';
import { EventCalendar } from '../components/EventCalendar';
import { useConfig } from '../context/ConfigContext';
import { formatDate } from '../utils/format';

interface DashboardAnnouncement {
  id: number;
  title: string;
  body: string;
  priority: string;
}

interface DashboardStats {
  active_announcements: DashboardAnnouncement[];
}

export function Home() {
  const { settings } = useConfig();
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get<DashboardStats>('/dashboard')
      .then(({ data }) => setStats(data))
      .catch((err: ApiError) => setError(err.message || 'Could not load the page.'));
  }, []);

  if (error) return <div className="alert alert-error">{error}</div>;
  if (!stats) return <p className="muted">Loading…</p>;

  return (
    <>
      <header className="page-header">
        <h1>Home</h1>
        <p className="muted">{formatDate(new Date(), settings.timezone)}</p>
      </header>

      <div className="card">
        <h2>Announcements</h2>
        {stats.active_announcements.length === 0 && <p className="muted">Nothing published.</p>}
        <ul className="simple-list">
          {stats.active_announcements.map((a) => (
            <li key={a.id}>
              <strong>
                {a.title} <span className={`badge badge-${a.priority}`}>{a.priority}</span>
              </strong>
              <small>{a.body}</small>
            </li>
          ))}
        </ul>
      </div>

      <EventCalendar />
    </>
  );
}
